import { nativeEnum, enum as zodEnum, object, string } from 'zod';

import { AudienceBroadcastMessageStatus } from '@occc/graphql';
import { DateTimeForFilterSchema, TimeRangeEnum } from '@occc/ui-forms';

export const MessageTypeEnum = zodEnum(['SMS', 'PUSH', 'BOTH']);

// AudienceBroadcastMessagesFilter
export const MessagingCampaignsFilterSchema = object({
  search: string().optional(),
  messageTypeEquals: MessageTypeEnum.optional(),
  statusEquals: nativeEnum(AudienceBroadcastMessageStatus).optional(),
  scheduledAt: TimeRangeEnum.optional(),
  scheduledDateFrom: DateTimeForFilterSchema.optional(),
  scheduledDateTo: DateTimeForFilterSchema.optional(),
});
